export const getGuestyTasksUrl = process.env.REACT_APP_GET_GUESTY_TASKS;
export const editGuestyTasksUrl =
    process.env.REACT_APP_HELPER_EDIT_GUESTY_TASKS;
export const getPlandayShiftsUrl =
    process.env.REACT_APP_HELPER_GET_PLANDAY_SHIFTS;
export const guestyMasterIntegrationUrl =
    process.env.REACT_APP_GUESTY_MASTER_INTEGRATION;

export const ERROR_MESSAGE =
    'There has been a problem with your fetch operation:';

export const STATUS_COLORS = {
    'in progress': 'blue',
    pending: 'gold',
    confirmed: 'green',
    completed: 'cyan',
    canceled: 'red',
};

export const UNASSIGNED_TASKS_ID = null;
export const UNASSIGNED_TASKS_POOL_ID = 'unassignedTasksPool';

export const TABS = {
    'City center': ['APE', 'STU', 'ROS', 'NAB', 'CIT', 'VEN', 'MEK'],
    Amager: ['SLE', 'BRI', 'NOR', 'FLO', 'DAH', 'FOL'],
    Aarhus: ['AUR'],
    'Living Suites': ['LIV'],
};

export const SHIFTS = {
    Amager: 21407,
    Aarhus: 21408,
    'City center': 21406,
    'Living Suites': 25896,
};

export const EMPLOYEE_EMAILS = [
    'ana@nordcollection.dk',
    'tss@nordcollection.dk',
    'kba@nordcollection.dk',
    'pzh@nordcollection.dk',
    'shk@nordcollection.dk',
    'kci@nordcollection.dk',
    'lbl@nordcollection.dk',
    'nvo@nordcollection.dk',
    'cer@nordcollection.dk',
    'lkh@nordcollection.dk',
    'ami@nordcollection.dk',
    'nkh@nordcollection.dk',
    'rac@nordcollection.dk'
];
